import { Controller } from '@hotwired/stimulus'
import bootstrap from 'bootstrap/dist/js/bootstrap'

export default class extends Controller {
  static targets = ['modal']

  connect() {}

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove('hidden')
  }

  close(event) {
    event.preventDefault()
    this.modalTarget.classList.add('hidden')
  }

  escClose(event) {
    if (event.key === 'Escape') this.modalTarget.classList.add('hidden')
  }

  /**
   * Bootstrap 5 modal: controller lives on the .modal element (no data-modal-target child).
   * Legacy: inner element has data-modal-target="modal" — hide via class.
   */
  hide() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add('hidden')
      return
    }
    if (this.element.classList.contains('modal')) {
      const instance = bootstrap.Modal.getInstance(this.element)
      if (instance) {
        instance.hide()
      }
    }
  }
}
